import { DEFAULT_COVER_IMG } from '@/common/components/HeadMetaTags/HeadMetaTags';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

/**
 * @returns '/wishlist'
 */
export const RouteToWishlistPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/wishlist', target: 'external' });
};
export const WishlistPageConfig: PageConfig = {
  readableName: 'Wishlist',
  analyticsGaName: 'wishlist',
  analyticsAthenaName: 'wishlist',
  pagePathnames: ['/wishlist'],
  displayPromoBar: true,
  defaultMeta: {
    title: `Your personal Wishlist | Displate`,
    description: `Your personal Displate wishlist. Save your favorite designs for later!`,
    coverImage: DEFAULT_COVER_IMG,
  },
};
